import React, { useContext, useState } from 'react';
import { Card, Title, Text, Switch, Space, message } from 'components';
import styled from 'styled-components';
import { setAnsweringDefaultEnabled } from 'api/AnsweringSubscriptionController';
import errorReporter from '@app/errorReporter';
import AppointmentDeskContext from '../AppointmentDeskContext';

const DefaultToggleCard = () => {
  const [loading, setLoading] = useState(false);

  const { answeringSubscription, defaultEnabled, setDefaultEnabled } =
    useContext(AppointmentDeskContext);

  const handleChange = async (newChecked: boolean) => {
    if (answeringSubscription) {
      setLoading(true);
      try {
        await setAnsweringDefaultEnabled(answeringSubscription.id, newChecked);
        setDefaultEnabled(newChecked);
      } catch (e) {
        message.error('Error updating default concierge preference');
        errorReporter.error(e);
      } finally {
        setLoading(false);
      }
    } else {
      setDefaultEnabled(newChecked);
    }
  };

  return (
    <StyledCard>
      <Space direction="vertical" size="middle" align="center">
        <Title level={2} data-cy="listing-default-title">
          Default concierge preference for new listings
        </Title>
        <Text>
          Default On:
          <StyledInlineSwitch
            checked={defaultEnabled}
            onChange={handleChange}
            loading={loading}
            data-cy="listing-default-toggle"
          />
        </Text>
        <Text
          type="secondary"
          textAlign="center"
          data-cy="listing-default-text"
        >
          Turn your preference on or off for new listings who are subscribed to
          the Live Concierge Service.
        </Text>
      </Space>
    </StyledCard>
  );
};

export default DefaultToggleCard;

const StyledCard = styled(Card)`
  ${Title} {
    margin-bottom: 0px;
  }
  text-align: center;
  padding: 0 5%;
`;

const StyledInlineSwitch = styled(Switch)`
  display: inline;
  & > div {
    display: inline;
  }
  margin-left: 8px;
`;
